import React from 'react';
import { Outlet } from 'react-router-dom';

const PlayerPage = () => {

    return <Outlet/>

}

export default PlayerPage